import { Icon } from '@design/components/icon/Icon';
import { GradientBar } from '@terminal/components/gradient-bar/GradientBar';
import clsx from 'clsx';
import { type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './AlfredThinkingFeedback.module.scss';
import {
  THINKING_FEEDBACK_DISMISS_DELAY_MS,
  useAlfredThinkingFeedbackDismissal,
} from './useAlfredThinkingFeedbackDismissal';

export interface AlfredThinkingFeedbackProps {
  conversationId: string;
  onNavigate: (conversationId: string) => void;
  onDismiss: () => void;
}

export const AlfredThinkingFeedback = ({
  conversationId,
  onNavigate,
  onDismiss,
}: AlfredThinkingFeedbackProps) => {
  const { t } = useTranslation(['chat']);
  const { dismissalVariant, handleAnimationEnd, handleNavigation, rootRef } =
    useAlfredThinkingFeedbackDismissal({
      conversationId,
      onNavigate,
      onDismiss,
    });

  const handleMouseDown = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div
      className={clsx(styles.root, {
        [styles.flyDismissal]: dismissalVariant === 'fly',
        [styles.fallbackDismissal]: dismissalVariant === 'fallback',
      })}
      data-thinking-feedback-visible
      data-testid="alfred-everywhere-thinking-feedback"
      onAnimationEnd={handleAnimationEnd}
      onMouseDown={handleMouseDown}
      ref={rootRef}
    >
      <button
        className={styles.card}
        data-testid="alfred-everywhere-thinking-feedback-card"
        onClick={handleNavigation}
        type="button"
      >
        <Icon iconName="Alfred" size={16} />
        <span className={styles.cardText} role="status">
          {t('chat:alfredEverywhereThinkingFeedback.thinking')}
        </span>
        <Icon iconName="ChevronLightRight" size={16} />
        <GradientBar
          className={styles.progressBar}
          durationMs={THINKING_FEEDBACK_DISMISS_DELAY_MS}
          height="4px"
          variant="progress"
        />
      </button>
    </div>
  );
};
